import GoogleMapComponent from '../components/shared/google-map';
import Layout from '../components/layout';
import React from 'react';
import SEO from '../components/seo';
import SectionTitles from '../components/shared/section-titles';
import { graphql } from 'gatsby';
import meta from '../constants/meta-descriptions';
import styled from 'styled-components';

export const TitleH1 = styled.h1`
	@media screen and (max-width: 720px) {
		font-size: 30px;
	}
`;

const ShopPage = ({ data }) => {
	const shops = data.allWordpressWpStores.edges
		.map(({ node }) => node.acf)
		.sort((a, b) => a.city.localeCompare(b.city));

	const refs = shops.map((_) => React.createRef());
	const scrollToRef = (id) =>
		window.scrollTo({ top: refs[id].current.offsetTop - 100, behavior: 'smooth' });

	return (
		<>
			<Layout activeTab={'/magazini/'}>
				<div style={{ paddingTop: '16rem' }}>
					<SEO
						title={meta.shops.title}
						description={meta.shops.metaDescription}
					/>
					<SectionTitles>
						<TitleH1>
							Нашите магазини в цяла
							<br />
							България
						</TitleH1>
						<hr className="center" />
					</SectionTitles>

					<div className="container text-center mt-5">
						<h3>Бърз достъп</h3>

						<div className="row mt-4">
							<div
								className="row"
								style={{
									margin: 'auto',
									maxWidth: 600
								}}
							>
								{shops.map(({ city }, index) => (
									<>
										<div
											style={{
												width: 180
											}}
											key={index}
										>
											<button
												className="clear"
												onClick={() => {
													scrollToRef(index);
												}}
											>
												<p className="link">{city}</p>
											</button>
										</div>
									</>
								))}
							</div>

							<hr className="big-blue" />
							{shops.map((shop, i) => {
								return (
									<section
										id={shop.wordpress_id}
										className="w-100"
										key={i}
									>
										<div className="w-100" key={i} ref={refs[i]}>
											<div className="w-100" key={i}>
												{i !== 0 && <hr className="small-blue" />}
												<Place {...shop} />
											</div>
										</div>
									</section>
								);
							})}
						</div>
					</div>
				</div>
			</Layout>
		</>
	);
};

const PlaceText = ({ city, address, telephone, working_hours }) => (
	<>
		<h2>{city}</h2>
		<div className="my-4">
			<h3>
				<span className="icon map-pin-shop mr-2"></span>Адрес:
			</h3>
			<p className="margin-left-offices">{address}</p>
		</div>
		<div className="my-4">
			<h3>
				<span className="icon blue-phone mr-2"></span>Телефон:
			</h3>
			<a href={'tel:' + telephone} className="margin-left-offices">
				{telephone}
			</a>
		</div>
		<div className="my-4">
			<h3>
				<span className="icon clock mr-2"></span>Работно време:
			</h3>
			<div
				className="margin-left-offices"
				dangerouslySetInnerHTML={{ __html: working_hours }}
			/>
		</div>
	</>
);

const Place = ({
	city,
	address,
	telephone,
	working_hours,
	mapState,
	officeFeatures,
	easyPayOffice,
	videoStream
}) => {
	officeFeatures = officeFeatures.length ? officeFeatures.split('\n') : [];
	easyPayOffice = easyPayOffice.length ? easyPayOffice.split('\n') : [];
	mapState = JSON.parse(mapState);

	return (
		<>
			<div className="row w-100 py-2">
				<div className="col-12 col-md-6 text-left">
					<PlaceText
						address={address}
						city={city}
						telephone={telephone}
						working_hours={working_hours}
						videoStream={videoStream}
					/>
				</div>
				<div className="col-12 col-md-6">
					<GoogleMapComponent height={350} mapState={mapState} />
					<div className="row mt-4">
						<div className="col-6 m-0 p-0 d-flex justify-content-start">
							<div>
								<h3>
									<span className="icon map-pin-dark mr-2"></span>
									Магазин на NetSurf:
								</h3>
								<ul className="blue-checks text-left">
									{officeFeatures.map((feature, index) => (
										<li className="blue-checks" key={index}>
											<p className="m-0 p-0">{feature}</p>
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className="col-6 m-0 p-0 d-flex justify-content-start">
							<div>
								<h3>
									<span className="icon easypay mr-2"></span>Каса на
									Easypay:
								</h3>
								<ul className="blue-checks text-left">
									{easyPayOffice.map((feature, index) => (
										<li className="blue-checks" key={index}>
											<p>{feature}</p>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export const query = graphql`
	query ShopPageQuery {
		allWordpressWpStores {
			edges {
				node {
					acf {
						wordpress_id
						city
						mapState
						address
						working_hours
						telephone
						officeFeatures
						easyPayOffice
						videoStream
					}
				}
			}
		}
	}
`;

export default ShopPage;

